
jQuery(document).ready(function ($) {
    "use strict";

    /**
     * Toggle mobile sub menu
     */

    $('.main-nav--mob .menu-item-has-children').on('click', function(e) {
        const el = $(this),
            topEl = $(this).parent();
        if($(window).width() < 998) {
            e.stopPropagation();
            if(el.hasClass('active')) {
                el.removeClass('active');
                el.find('> .sub-menu').slideUp();
            } else {
                topEl.find('.menu-item-has-children').each(function() {
                    $(this).removeClass('active');
                    $(this).find('> .sub-menu').slideUp();
                });
                el.addClass('active');
                el.find('> .sub-menu').slideDown();
            }
        }
    });

});
